<template>
  <v-container fluid>
    <v-row dense>
      <v-col style="min-width: 400px">
        <v-card>
          <v-card-title><T>Оператор</T></v-card-title>
          <v-divider></v-divider>
          <v-banner>
            <v-icon class="mr-3">mdi-comment-alert</v-icon>
            <T>Вход по коду считается входом оператора вне зависимости от роли учетной записи в r_keeper</T>
          </v-banner>
          <v-card-text>
            
            <CheckBox
              :loading="loading"  
              :label="$t('Требовать регистрацию в смене')"
              :hint="$t('Вход по коду возможен только если пользователь r_keeper зарегистрирован в текущей кассовой смене.')"

              :original_value="authorization.operator_registration_required"
              v-model="local_authorization.operator_registration_required"
            />
            
            <CheckBox  
              :loading="loading"  
              :label="$t('Предоставлять права администратора')"
              :hint="$t('Вход по коду будет предоставлять доступ к функциям, обычно доступным только администратору.')"

              :original_value="authorization.operator_grant_admin"
              v-model="local_authorization.operator_grant_admin"
            />

          </v-card-text>
        </v-card>
      </v-col>
      <v-col style="min-width: 350px">
        <v-card>
          <v-card-title>
            <T>Администраторы</T>
            <v-spacer></v-spacer>
            <v-btn
              @click="new_admin = true"
              color="primary"
              dark
              fab
              x-small
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-list max-height="calc(100vh - 250px)" outline style="overflow-y: auto">
            <transition-group name="slide" duration="100">
              <v-list-item v-for="admin in config.authorization.admin_list" :key="admin.fingerprint" class="hover-master" link>
                <v-list-item-avatar><v-icon>mdi-account</v-icon></v-list-item-avatar>
                <v-list-item-title>{{admin.username}}</v-list-item-title>
                <div class="hover-slave">
                  <v-btn icon color="primary" @click="() => remove_admin = admin.username"><v-icon>mdi-delete</v-icon></v-btn>
                </div>
                <!-- <v-list-item-action></v-list-item-action> -->
              </v-list-item>
            </transition-group>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog max-width="400" scrollable v-model="new_admin">
      <v-card >
        <v-form @submit.prevent="addAdmin" ref="form">
          <v-card-title><T>Добавление учетной записи администратора</T></v-card-title>
          <v-card-text>
            <TextField 
              :label="$t('Логин')"
              :rules="[rules.require, rules.minlen(3)]"

              v-model="username"
            />
            <TextField 
              :label="$t('Пароль')"
              :rules="[rules.require]"

              password

              v-model="password"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn :loading="local_loading" color="primary" type="submit" text> <v-icon>mdi-save</v-icon><T>Создать</T></v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog persistent :value="!!remove_admin" max-width="400">
      <v-card>
        <v-card-title><T>Подтверждение</T></v-card-title>
        <v-card-text>
          <T>Это действите приведет к удалению учетной записи администратора</T> {{remove_admin}}<br>
          <T>Продолжить?</T>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="local_loading" @click="remove_admin = ''" color="black" text> <v-icon>mdi-close</v-icon><T>Отмена</T></v-btn>
          <v-btn :loading="local_loading" color="primary" text @click="removeAdmin"> <v-icon>mdi-check</v-icon><T>Удалить</T></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import TextField from '../../common/TextField.vue'
import CheckBox from '../../common/CheckBox'
import settings_group_mixin from '../settings_group_mixin'

export default {
  mixins: [settings_group_mixin],
  data: () => ({
    local_loading: false,
    new_admin: false,
    username: '',
    password: '',
    remove_admin: ''
  }),
  computed: {
    authorization(){
      return this.config?.authorization || {}
    },
    local_authorization(){
      return this.local_config?.authorization || {}
    }
  },
  methods: {
    submit(){
      return {
        authorization: { 
          ...this.local_config.authorization,
          admin_list: this.config.authorization.admin_list
        }
      }
    },
    async loadAdminList(){
      this.local_loading = true
      try {
        this.admin_list = await this.$store.dispatch('apiQuery', {method: '/admin_list'})
      } finally {
        this.local_loading = false
      }
    },
    async addAdmin(){
      if (!this.$refs.form.validate()){
        return
      }
      this.local_loading = true
      try {
        await this.$store.dispatch('addAdmin', {login: this.username, password: this.password})
        
        this.new_admin = false 
        this.username = ''
        this.password = ''

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Добавленая новая учетная запись администратора'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
    async removeAdmin(){
      this.local_loading = true
      try {
        await this.$store.dispatch('removeAdmin', {login: this.remove_admin})
        
        this.remove_admin = ''
        
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Учетная запись администратора удалена'),
          message_class: 'success'
        })
      } finally {
        this.local_loading = false
      }
    },
  },
  async mounted(){
    await this.loadAdminList()
  },
  components:{
    CheckBox,
    TextField
  }
}
</script>

<style scoped>
.moving {
  opacity: 0;
  cursor: grabbing !important;
}
.hover-slave {
  opacity: 0;
  transition: all .1s;
  cursor: pointer;
}
.hover-slave-wid {
  opacity: 0;
  width: 0;
  transition: all .1s;
  cursor: pointer;
}
.hove-slave-hid {
  opacity: 1;
  width: 100%;
  transition: all .1s;
}
.hover-master:hover .hover-slave, .hover-master:hover .hover-slave-wid {
  /* width: 100%; */
  opacity: 1;
}
.hover-master:hover .hove-slave-hid {
  width: 0;
  opacity: 0;
}
</style>